import { create } from "zustand";
import { promoService } from "./promoService";
import { isWithinDuration, PromoState } from "./types";

export const usePromoStore = create<PromoState>((set) => ({
  promoCodes: [],
  isLoading: false,
  error: null,

  checkPromo: async (code: string) => {
    const trimmedCode = code.trim();

    if (!trimmedCode) {
      set({
        promoCodes: [],
        error: "Promo code is required",
        isLoading: false,
      });
      return null;
    }

    set({ isLoading: true, error: null });

    try {
      const promoCodes = await promoService.checkPromo(trimmedCode);
      const promo = promoCodes[0];

      if (!promo) {
        set({
          promoCodes: [],
          isLoading: false,
          error: "Promo code not found",
        });
        return null;
      }

      if (!promo.is_active) {
        set({
          promoCodes: [],
          isLoading: false,
          error: "Promo code is inactive",
        });
        return null;
      }

      if (!isWithinDuration(promo.duration)) {
        set({
          promoCodes: [],
          isLoading: false,
          error: "Promo code has expired",
        });
        return null;
      }

      set({ promoCodes: [promo], isLoading: false, error: null });
      return [promo];
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "Promo check failed";
      set({
        promoCodes: [],
        isLoading: false,
        error: message,
      });
      return null;
    }
  },

  clearPromo: () => {
    set({ promoCodes: [], error: null });
  },
}));
